export default __webpack_public_path__ + "9ecf47848a7079a8b5a9e5acfde89644.jpg";